import React, { useContext } from "react";
import { useMsal } from "@azure/msal-react";
import { UserContext } from "../../components/UserContext";

/**
 * Renders a sign-out button
 *
 * @param {"menu" | "button"} variant - "menu" (default) renders the original
 *   dropdown list item; "button" renders a full-width confirm button for use
 *   in the sign-out confirmation modal.
 * @param {() => void} onSignOut - called right after logout is triggered.
 */
export const SignOutButton = ({ variant = "menu", onSignOut }) => {
  const { darkTheme, setResToken, setCodeNavigatorToken, setGraphData, setSelectedHighlight, setIsOpenLink } =
    useContext(UserContext);
  const { instance } = useMsal();

  const handleLogout = (logoutType) => {
    if (logoutType === "popup") {
      instance.logoutPopup({
        postLogoutRedirectUri: "/",
        mainWindowRedirectUri: "/",
      });

      // MY TRICK
      localStorage.removeItem("access_token");
      localStorage.removeItem("cn_access_token");
      localStorage.removeItem("uInfo");
      localStorage.removeItem("msInfo");
      localStorage.removeItem("previousUrl");
      localStorage.removeItem("currentUrl");
      localStorage.removeItem("versionNameId");

      // Date: 12 Dec, 2024
      // Ref: Email/Meeting on 11 Dec, 2024 from Manigandan to add cn Username and version.
      // Changes: Remove Storing cn Username and version by msal-logout.
      localStorage.removeItem("cn_userInfo");

      setSelectedHighlight("");
      setIsOpenLink("");
      setResToken("");
      setCodeNavigatorToken("");
      setGraphData(null);
    } else if (logoutType === "redirect") {
      instance.logoutRedirect({
        postLogoutRedirectUri: "/",
      });

      // MY TRICK
      localStorage.removeItem("access_token");
      localStorage.removeItem("cn_access_token");
      localStorage.removeItem("uInfo");
      localStorage.removeItem("msInfo");
      setResToken("");
      setCodeNavigatorToken("");
      setGraphData(null);
    }
  };

  if (variant === "button") {
    return (
      <button
        onClick={() => {
          handleLogout("popup");
          onSignOut?.();
        }}
        className="flex-1 py-2 rounded-full text-sm font-semibold text-White transition-all active:scale-[0.97] shadow-sm bg-BoldRed hover:bg-BoldRed/90"
      >
        Sign out
      </button>
    );
  }

  return (
    <ul>
      <li
        className={`cursor-pointer transition-all px-4 py-1 rounded-xl my-1 ${
          darkTheme
            ? "hover:bg-opacity-70 bg-blue-600 active:bg-opacity-25"
            : "hover:bg-opacity-70 active:bg-opacity-25 bg-lighGray"
        }`}
        onClick={() => handleLogout("popup")}
      >
        {/* Sign out using Popup */}
        Sign out
      </li>
      {/* <li
        className={`cursor-pointer transition-all px-4 py-1 rounded-xl my-1 ${
          darkTheme
            ? "hover:bg-opacity-70 bg-blue-600 active:bg-opacity-25"
            : "hover:bg-opacity-70 active:bg-opacity-25 bg-lighGray"
        }`}
        onClick={() => handleLogout("redirect")}
      >
        Sign out using Redirect
      </li> */}
    </ul>
  );
};
